module.exports = __webpack_public_path__ + "9a944aa97ee5a1ca130979fd991e6cb2.svg";